import isString from 'lodash/isString';
import isObject from 'lodash/isObject';
import { exception } from '@/exceptions/Exceptions';

export const formatAddress = (addressString, postcode = '', includeCountry = false) => {
    if (!isString(addressString) || addressString === '') exception('addressString is not a valid string.');

    // explode comma string into array
    let addressFields = addressString.replace(/^\s+|\s+$/g, '').split(/\s*,\s*/);

    // some addresses has identical values in the first and second line, so we need to remove duplication
    if (addressFields[0] === addressFields[1]) {
        addressFields.splice(1, 1);
    }

    // If the 3rd line of the address is present address line 1 will be a merge of address field 0 & 1.
    let addressLine1 = addressFields[2] ? addressFields[0].concat(', ', addressFields[1]).trim() : addressFields[0];

    let addressLine2 = addressFields[2] ? addressFields[2] : addressFields[1];

    // if address field 5 exists, use as city else use the last address field.
    let city = addressFields[5] ? addressFields[5] : addressFields[addressFields.length - 1];

    let country = includeCountry ? process.env.VUE_APP_COUNTRY_ISO : '';

    return {
        houseNumber: '',
        addressLine1: addressLine1,
        addressLine2: addressLine2,
        city: city,
        postcode: postcode,
        country: country,
    };
};

export const getFullAddressString = (address) => {
    if (!isObject(address)) exception('address is not a valid object.');

    let fullAddress = address.addressLine1;

    if (address.addressLine2) {
        fullAddress = fullAddress.concat(', ', address.addressLine2).trim();
    }

    fullAddress = fullAddress.concat(', ', address.city).trim();

    if (address.postcode) {
        fullAddress = fullAddress.concat(', ', address.postcode).trim();
    }

    if (address.country) {
        fullAddress = fullAddress.concat(', ', address.country).trim();
    }

    return fullAddress;
};

export const getFormattedAddressForCountry = (address, fullName, country = process.env.VUE_APP_COUNTRY_ISO) => {
    const address1 = address?.address1 || '';
    const address2 = address?.address2 || '';
    const houseNumber = address?.houseNumber || '';
    const postcode = address?.postcode || '';
    const city = address?.city || '';

    switch (country) {
    case 'DEU': return `${fullName} <br>
                        ${address1} ${houseNumber} ${address1 || houseNumber ? '<br>' : ''}
                        ${postcode}, ${city}`;
    case 'NLD': return `${fullName} <br>
                        ${houseNumber}, ${address1} ${address1 || houseNumber ? '<br>' : ''}
                        ${postcode}${postcode ? '<br>' : ''}
                        ${city}`;
    case 'USA': return `${fullName} ${fullName ? '<br>' : ''}
                            ${houseNumber}${houseNumber ? '<br>' : ''}
                            ${address1}${address1 ? '<br>' : ''}
                            ${address2} ${city}${address2 || city ? '<br>' : ''}
                            ${postcode}`;
    };
};
